import { Check, Minus } from "lucide-react";
import { euro } from "@/lib/api";

/** Choix des soins : un clic ajoute, le même soin peut être pris plusieurs fois. `value` = liste de slugs, `max` = nombre de soins de la formule. */
export function SubPicker({ products, value, onChange, max }) {
  const list = Array.isArray(products) ? products : [];
  const count = (slug) => value.filter((s) => s === slug).length;
  const add = (slug) => { if (max === 1) onChange([slug]); else if (value.length < max) onChange([...value, slug]); };
  const remove = (slug) => { const i = value.lastIndexOf(slug); if (i >= 0) onChange(value.filter((_, j) => j !== i)); };
  return (
    <div data-testid="sub-picker">
      <p data-testid="sub-picker-count" className="mb-4 text-sm text-[var(--parchment)]/85">
        {value.length < max ? `Choisissez encore ${max - value.length} soin${max - value.length > 1 ? "s" : ""}` : max > 1 ? `Vos ${max} soins sont choisis` : "Votre soin est choisi"} · {value.length} / {max}
      </p>
      <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {list.map((p) => {
          const n = count(p.slug);
          const full = max > 1 && value.length >= max && !n;
          return (
            <li key={p.slug} className="relative">
              <button type="button" data-testid={`sub-pick-${p.slug}`} onClick={() => add(p.slug)} disabled={full}
                className={`flex h-full w-full flex-col overflow-hidden rounded-sm border text-left transition-[border-color,opacity,transform] duration-200 hover:-translate-y-0.5 ${n ? "border-[var(--gold)] bg-[rgba(217,180,106,0.08)]" : "border-[var(--line)] hover:border-[var(--gold)]/60"} ${full ? "opacity-45" : ""}`}>
                <span className="aspect-square w-full overflow-hidden bg-[var(--ink-2)]"><img src={p.image} alt={p.name} loading="lazy" className="h-full w-full object-cover" /></span>
                <span className="flex flex-1 flex-col gap-1 p-3">
                  <span className="text-sm leading-snug">{p.name}</span>
                  <span className="text-xs text-[var(--muted)]"><s>{euro(p.price)}</s> · inclus</span>
                </span>
              </button>
              {n ? (
                <div className="absolute right-2 top-2 flex items-center gap-1">
                  <span data-testid={`sub-pick-count-${p.slug}`} className="flex h-7 min-w-7 items-center justify-center gap-1 rounded-full bg-[var(--gold)] px-2 text-xs font-semibold text-[var(--ink)]"><Check className="h-3 w-3" />{n > 1 ? `×${n}` : ""}</span>
                  <button type="button" data-testid={`sub-unpick-${p.slug}`} onClick={() => remove(p.slug)} aria-label={`Retirer ${p.name}`} className="flex h-7 w-7 items-center justify-center rounded-full bg-[var(--ink)] text-[var(--parchment)] ring-1 ring-[var(--line)]"><Minus className="h-3 w-3" /></button>
                </div>
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
